import React, {SetStateAction} from 'react';

import IconButton from "@mui/material/IconButton";
import {Theme} from "@mui/material";
import Rotate90DegreesCcwIcon from "@mui/icons-material/Rotate90DegreesCcw";
import Box from "@mui/material/Box";

import {toRem} from "../../../../themes/utils";

type FullScreenImageProps = {
    setRotationInDrawer: React.Dispatch<SetStateAction<number>>
    fileData: string
    rotationInDrawer: number
}

const FullScreenImage: React.FC<FullScreenImageProps> = ({ setRotationInDrawer, fileData, rotationInDrawer}) => {
    return (
        <>
            <IconButton onClick={() => setRotationInDrawer(prevState => prevState === -3 ? 0 : prevState -1)} sx={{position: "sticky", top: toRem(10), right: toRem(16), backgroundColor: (theme: Theme) => theme.palette.grey[400], border: "1px solid #fff", zIndex: 25, alignSelf: "end", transform: "translateY(20px)"}}>
                <Rotate90DegreesCcwIcon/>
            </IconButton>
            <Box sx={{position: "relative", height: "auto", width: "100%", display: "flex", flexDirection: "column", backgroundColor: (theme: Theme) => theme.palette.grey[200], mt: 2, overflow: "auto", transform: "translateY(-50px)"}}>
                <img src={fileData} alt="id" style={{width: "100%", height: "100%", transform: `rotate(${rotationInDrawer * 90}deg)`, zIndex: 3}}/>
            </Box>
        </>
    );
};

export default FullScreenImage;